// extracted by mini-css-extract-plugin
module.exports = {"submitButton":"Button_submitButton__3griL","disabledButton":"Button_disabledButton__2KZCY"};